import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useApi } from '@/functions/api'
import { useInitApp } from '@/models/app'
import { useAuthStore } from '@/stores/auth'

export function useAuthLogin () {
  const api = useApi()

  const { init } = useInitApp()

  const form = reactive({
    username: '',
    password: '',
    remember: true,
  })
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submit = async () => {
    try {
      submitting.value = true
      errors.value = {}
      await api.POST('admin/login', form)
      await init() // let init do the redirect to home
    } catch (error) {
      errors.value = api.formErrors(error)
      submitting.value = false
    }
  }

  return {
    form,
    submitting,
    errors,
    submit,
  }
}

export function useAuthLogout () {
  const api = useApi()
  const router = useRouter()
  const auth = useAuthStore()

  return async () => {
    router.replace({ name: 'login' })
    auth.logout()
    await api.POST('admin/logout')
  }
}
